import { useQuery } from 'react-query';
import { getMenu } from '../../../service';
import blog from '../.././../assets/images/icons/w/blog.svg';
import facebook from '../.././../assets/images/icons/w/facebook.svg';
import instagram from '../.././../assets/images/icons/w/instagram.svg';
import youtube from '../.././../assets/images/icons/w/youtube.svg';
import { Box } from '@chakra-ui/react';

type Props = {
  slug: string;
  type?: string;
  target?: string;
  direction?: string;
  isMobile?: boolean;
  onHover: (id:number) => void;
};

const snsIcon:any = {
  blog: blog,
  facebook: facebook,
  instagram: instagram,
  youtube: youtube,
}

function Nav({ slug, type, target, isMobile, onHover }: Props) {
  const { isLoading, error, data } = useQuery(`getMenu-${slug}`, () => getMenu(slug), {
    staleTime: 1000 * 60 * 60,
    cacheTime: 1000 * 60 * 60,
  });

  return (
    <>
    {
      !isLoading && !error && (
        <>
        <nav>
          <ul>
            {
              data.items.map((item:any, index:number) => (
                <li key={index} className={item.classes.join(' ')} onMouseEnter={() => onHover(item.ID)} onMouseLeave={() => onHover(0)}>
                  <a href={item.url} target={target} rel={target === '_blank' ? 'noreferrer' : undefined}> 
                    {
                      type === 'icon' ? (
                        <>
                        <img src={snsIcon[item.title]} alt={item.title} />
                        </>
                        ) : (
                        <span>{item.title}</span>
                      )
                    }
                  </a>
                  {isMobile && item.child_items && (
                    <ul>
                      {
                        item.child_items.map((child:any, index:number) => (
                          <li key={index}>
                            <a href={child.url} target={child.target} rel={child.target === '_blank' ? 'noreferrer' : undefined}>{child.title}</a>
                          </li>
                        ))
                      }
                    </ul>
                  )}
                </li>
              ))
            }
          </ul>
          {
            isMobile && (
              <Box h={100} />
            )
          }
        </nav>
        </>
      )
    }
    </>
  );
}

Nav.defaultProps = {
  target: '_self'
};

export default Nav;
